export { default as userThumbnail } from './user-thumbnail.png';
export { default as seriesThumbnail } from './series-thumbnail.svg';
export { default as emptyThumbnail } from './empty-thumbnail.svg';
export { default as undrawEmpty } from './undraw_empty.svg';
export { default as undrawJoyride } from './undraw_joyride_hnno.svg';
export { default as undrawBlankCanvas } from './undraw_blank_canvas_3rbb.svg';
export { default as undrawBugFixing } from './undraw_bug_fixing_oc7a.svg';
export { default as undrawPageNotFound } from './undraw_page_not_found_su7k.svg';
export { default as undrawServerDown } from './undraw_server_down_s4lk.svg';
export { default as undrawUpdate } from './undraw_update_uxn2.svg';
export { default as undrawLogin } from './undraw_login_v483.svg';

// export { default as undrawSearching } from './undraw_searching.svg';
